import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import swal from 'sweetalert2';
import { PaygPaymentTransmissionPerformanceModel } from '../../models/payg/payg-payment-transmission-performance.model';
import { PaygService } from '../../services/payg.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../utilities/route.utilities';


@Component({
    selector: 'payment-transmission-item',
    templateUrl: './payment-transmission-item.component.html'
})
export class PaymentTransmissionItemComponent implements OnInit, OnDestroy {

    subscriptions: any[] = [];
    paymentTransmissionPerformance: PaygPaymentTransmissionPerformanceModel[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;

    constructor(
        private paygService: PaygService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.subscriptions.push(
            router.events.subscribe(event => {
                if (event instanceof NavigationEnd)
                    this.ngOnInit();
            })
        );
    }

    ngOnInit() {
        this.paymentTransmissionPerformance = [];
        let clientId = getParamFromAncestorRoute(this.route, 'clientId');
        let siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInfoClick() {
        swal({
            title: 'Payment Transmission Performance',
            html: '<p style="text-align: left;">This chart is considering the total payments made in the date filter set on the page, \
                                            and exposing the quantity of payments that transmit from payment made to the PAYG device within each minute quantity window.</p>\
              <p style="text-align: left;">In most cases payments should reach PAYG devices within 10 minutes. However, the time this can take can depend on the performance of the mobile network connection in your customers area.\
                                          If credit has not reached the PAYG device within 2 hours past the payment time, then it is indicative of a problem.</p>\
              <p style="text-align: left;">If continuously payments are taking longer to transmit than expected, we’d recommend speaking to Switch2,\
                                          there may be signal issues in your customers properties or other concerns we could investigate and resolve.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
